import { assocPath, mergeDeepRight, omit, find, propEq, without, assoc } from 'ramda';

/*
 * Given map note information, combine and return a MapNote
 * @sig createNewMapNote :: (Object, string, string, Object, string, string) -> MapNote
 */
const createNewMapNote = (updatedFields, venueId, ordinalId, tempMapNotelet, levelId, structureId) => {
    const mapNote = {
        subject: updatedFields.subject,
        noteStatus: 'open',
        description: updatedFields.description || '',
        noteType: updatedFields.noteType,
        location: {
            venueId,
            ordinalId: `ordinal: ${ordinalId}`,
            latitude: tempMapNotelet.location.latitude,
            longitude: tempMapNotelet.location.longitude,
        },
    };
    const mapNoteWithLevelId = levelId ? assocPath(['location', 'levelId'], levelId, mapNote) : null;
    const mapNoteWithStructureId = structureId ? assocPath(['location', 'structureId'], structureId, mapNote) : null;
    if (levelId && structureId) return mergeDeepRight(mapNoteWithLevelId, mapNoteWithStructureId);
    if (levelId) return mapNoteWithLevelId;
    if (structureId) return mapNoteWithStructureId;
    return mapNote;
};

/*
 * Given the latLng and venueId, return a temporary MapNote with an id of 1
 * @sig createNewMapNote :: (Object, string) -> tmpMapNote
 */
const createTempMapNotelet = (latLng, venueId) => ({
    id: -1,
    noteStatus: 'open',
    location: {
        latitude: latLng.lat,
        longitude: latLng.lng,
        venueId,
    },
});

/*
 * Given the new note type, return the value 'noType' if of value '---'
 * @sig isNoType :: string -> string
 */
const isNoType = value => (value === '---' ? 'noType' : value);

/*
 * Given the fields to omit and the mapnote, return new mapNote without the fields
 * @sig removeFields :: ([string], MapNote) -> MapNote
 */
const removeFields = (fieldsToOmit, mapNote) => omit(fieldsToOmit, mapNote);

/*
 * Given an array of MapNotelets and a noteId, find the MapNotelet
 * @sig findMapNotelet :: (number, [Object]) -> MapNote
 */
const findMapNotelet = (noteId, mapNotelets) => find(propEq(noteId, 'id'))(mapNotelets);

/*
 * Given a MapNotelet to be deleted and an array of MapNotelets, remove that MapNotelet from the array and return
 * @sig updateMapNotelet :: (number, [Object]) -> MapNote
 */
const updateMapNotelet = (notelet, mapNotelets) => without([notelet], mapNotelets);

/*
 * Given a the totals and a status to reduce from, subtract from that total
 * @sig deleteNoteletFromTotals :: (Object, string) -> Object
 */
const deleteNoteFromTotals = (totals, noteStatus) => assoc(noteStatus, totals[noteStatus] - 1, totals);

export {
    createNewMapNote,
    createTempMapNotelet,
    isNoType,
    removeFields,
    findMapNotelet,
    updateMapNotelet,
    deleteNoteFromTotals,
};
